import { Center, Divider, Heading, Text } from "@chakra-ui/react";
import Link from "next/link";

const ProofOfFan = () => {
  return (
    <>
      <br />
      <Center>
        <Heading as="h2" mt={20} size="lg">
          Proof of Fan
        </Heading>
      </Center>
      <Divider mt={20} />
      <Center>
        <Text fontSize="xl" maxW={"md"}>
          <br />
          Collecting music is in.
          <br />
          <br />
          Whether that be in the digital or physical domain, the appetite for
          building a music collection{" "}
          <Link href="https://unlockyoursound.com/people-do-buy-music-actually">
            is back in fashion.
          </Link>
          <br />
          <br />
          So what does collecting offer that streaming doesn{`'`}t?
          <br />
          <br />
          Proof.
          <br />
          <br />
          It provides fans a way to show off.
          <br />
          <br />
          It{`'`}s their way of saying {`"I discovered them before you did"`}.
          <br />
          <br />
          And for their favorite musicians, it{`'`}s proof of who really cares.
          <br />
          <br />
          By collecting your music, your fans can rise above the noise, and
          demonstrate their appreciation of your work.
          <br />
          <br />
          That{`'`}s what we want to facilitate at Songcards.
          <br />
        </Text>
      </Center>
      <br />
      <Center mb={10}></Center>
    </>
  );
};

export default ProofOfFan;
